import { dateUtils } from 'shared';

/**
 * Converts ISO datetime string to Unix timestamp in point data
 */
const convertPointToUnix = (
  point: Record<string, unknown>,
): Record<string, unknown> => {
  if (typeof point.at === 'string') {
    return { ...point, at: dateUtils.toUnix(point.at) };
  }
  return point;
};

/**
 * Converts ISO datetime strings to Unix timestamps in segment data
 */
const convertSegmentToUnix = (
  segment: Record<string, unknown>,
): Record<string, unknown> => {
  const result = { ...segment };
  if (segment.dep && typeof segment.dep === 'object') {
    result.dep = convertPointToUnix(segment.dep as Record<string, unknown>);
  }
  if (segment.arr && typeof segment.arr === 'object') {
    result.arr = convertPointToUnix(segment.arr as Record<string, unknown>);
  }
  return result;
};

/**
 * Converts all ISO datetime strings to Unix timestamps for bloomreach
 */
export const convertToBloomreachFormat = (
  data: Record<string, unknown>,
): void => {
  // Convert top-level datetime fields
  if (typeof data.from_dep === 'string') {
    data.from_dep = dateUtils.toUnix(data.from_dep);
  }
  if (typeof data.from_arr === 'string') {
    data.from_arr = dateUtils.toUnix(data.from_arr);
  }
  if (typeof data.to_dep === 'string') {
    data.to_dep = dateUtils.toUnix(data.to_dep);
  }
  if (typeof data.to_arr === 'string') {
    data.to_arr = dateUtils.toUnix(data.to_arr);
  }

  // Convert segments
  if (Array.isArray(data.segments_data_from)) {
    data.segments_data_from = data.segments_data_from.map(segment =>
      convertSegmentToUnix(segment as Record<string, unknown>),
    );
  }
  if (Array.isArray(data.segments_data_to)) {
    data.segments_data_to = data.segments_data_to.map(segment =>
      convertSegmentToUnix(segment as Record<string, unknown>),
    );
  }
};
